import React, {FC} from 'react';

import './styles.scss';

interface IProps {
  color?: string;
  title?: string;
  text?: string;
}
const PageHero: FC<IProps> = ({color, title, text}) => {
  return (
    <div className="page-hero">

        <div className="header-title" style={{backgroundColor: color}}>
          <div className="header-title-wrapper">
            <h1>{title}</h1>
            <p> {text}</p>
          </div>

      </div>
    </div>
  );
};

export default PageHero;
